





























import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class IconGermany extends Vue {
  @Prop({default: 26}) public readonly width!: number;
  @Prop({default: 34}) public readonly height!: number;
}
